import { useGetAccountQueryOptions } from "@/api/account/account"
import { useGetCustomerQueryOptions } from "@/api/customer/customer"
import { MyAccountRoute } from "@/constants/routes/myAccount"
import ErrorReporter from "@/services/ErrorReporter"
import { useQueryClient } from "@tanstack/vue-query"
import { NavigationGuard } from "vue-router"

export const offersAndRewardsGuard: NavigationGuard = async () => {
  const queryClient = useQueryClient()

  try {
    const customerQueryOptions = useGetCustomerQueryOptions()
    const accountId = (await queryClient.ensureQueryData(customerQueryOptions))
      .accountIDLastVisited

    if (!accountId) throw new Error("accountId not found")

    const accountQueryOptions = useGetAccountQueryOptions(accountId)
    const { isClosed, isTerminating } =
      await queryClient.ensureQueryData(accountQueryOptions)

    if (isClosed || isTerminating) {
      return { path: MyAccountRoute.home }
    }
  } catch (error) {
    ErrorReporter.report(error)
    return { path: MyAccountRoute.home }
  }
}
